import { RichText } from '@page-builder/Components/RichText/RichText';

export const renderRichText = (
  condition: boolean,
  ecomContent: string | undefined,
  investorContent: string | undefined,
) => {
  if (!ecomContent && !investorContent) return null;
  return condition ? (
    <RichText noPadding richText={ecomContent} />
  ) : (
    <RichText noPadding richText={investorContent} />
  );
};

export const renderDescription = (
  condition: boolean,
  ecomDescription: string | undefined,
  investorDescription: string | undefined,
) => {
  if (!ecomDescription && !investorDescription) return null;
  return condition ? (
    <RichText richText={ecomDescription} />
  ) : (
    <RichText richText={investorDescription} />
  );
};
